import { render, staticRenderFns } from "./TheSupplierContainer.vue?vue&type=template&id=6aea6c6e&scoped=true"
import script from "./TheSupplierContainer.vue?vue&type=script&lang=js"
export * from "./TheSupplierContainer.vue?vue&type=script&lang=js"
import style0 from "./TheSupplierContainer.vue?vue&type=style&index=0&id=6aea6c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea6c6e",
  null
  
)

export default component.exports